// PostHog project API keys are public client-side identifiers (not secrets),
// so — same as APP_CONFIG — they live here rather than in an env var.
// `enabled` stays false until a real key is filled in, so this ships inert.
export const ANALYTICS_CONFIG: Record<
  'local' | 'dev' | 'qa' | 'app',
  { apiKey: string; apiHost: string; enabled: boolean }
> = {
  // Off by default: localhost resolves to the same api-dev backend as the
  // deployed dev environment, so without this every local `npm start`
  // session would write into the dev project's real usage numbers. Reuses
  // the dev project's key so flipping `enabled` to true locally (uncommitted)
  // is enough to smoke-test against it when needed.
  local: {
    apiKey: 'phc_mKENo5ANSB6PeYanydhDCe26Ynv2tzUQTd4GDTXU2VrA',
    apiHost: 'https://us.i.posthog.com',
    enabled: false,
  },
  dev: {
    apiKey: 'phc_mKENo5ANSB6PeYanydhDCe26Ynv2tzUQTd4GDTXU2VrA',
    apiHost: 'https://us.i.posthog.com',
    enabled: true,
  },
  qa: {
    apiKey: '',
    apiHost: 'https://us.i.posthog.com',
    enabled: false,
  },
  app: {
    apiKey: '',
    apiHost: 'https://us.i.posthog.com',
    enabled: false,
  },
};
